export default () => {
	const uAg = navigator.userAgent;
	return uAg && (/rv:11.0/.test(uAg) || /MSIE 10.0/.test(uAg));
};
